import { useGetEmpPhotoQuery } from '@Store/api/dictionaryApiSlice';
import { User, UserReplacement } from '@Types/index';
import { Avatar, List } from 'antd';

interface EmployeeItem {
  user: User | UserReplacement;
  onUserSelect: (user: User | UserReplacement) => void;
}

const EmployeeItem: React.FC<EmployeeItem> = ({ user, onUserSelect }) => {
  const { data: userPhoto } = useGetEmpPhotoQuery(user.empImageName || '');

  return (
    <List.Item onClick={() => onUserSelect(user)}>
      <List.Item.Meta
        avatar={<Avatar size={32} src={userPhoto} />}
        title={<span>{user.empName}</span>}
        description={<span>{user.occupation}</span>}
      />
    </List.Item>
  );
};

export default EmployeeItem;
